// blog section
class BlogSlider {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }
  slider = () => {
    let sliders = qsa('.man-mag-slider-js',this.parent);
    if(!sliders){
      return;
    }
    if (window.innerWidth > 767) {
      let noOfBlocks = qs(".no-of-blogs-js").value;
      if(noOfBlocks <= 3) {
        return false;
      }
    }
    sliders.forEach(element => {
      new Swiper(element, {
        loop: true,
        slidesPerView: 3,
        slidesPerGroup: 1,
        speed: 1000,
        spaceBetween: 30,
        shortSwipes: true,
        navigation: {
          nextEl: ".slider-arrow-next",
          prevEl: ".slider-arrow-prev",
        },
        breakpoints: {
          1: {
            slidesPerView: 1,
            initialSlide:1
          },
          768: {
            slidesPerView: 2,
            initialSlide:1
          },
          1024: {
            slidesPerView: 3,
            grabCursor:true,
          },
        },
      });
    }); 
  }
}
new BlogSlider(qs(".the-man-mag-section-js"));